// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import PopoverBar from './popover_bar';

export default PopoverBar;
